// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchPage_root__ALDXi","heroWrap":"SearchPage_heroWrap___B6HO","searchBar":"SearchPage_searchBar__ZCabI","configurator":"SearchPage_configurator__b4KY_"};